/* Immortal Glory — Season One sections: gallery arrows, lightbox, click-to-play video. Idempotent; safe to load once per section. */
(function () {
  if (window.__igSeasonInit) return;
  window.__igSeasonInit = true;

  function init(root) {
    root = root || document;

    // gallery arrows
    root.querySelectorAll('.ig-gallery:not([data-ig-ready])').forEach(function (g) {
      g.setAttribute('data-ig-ready', '1');
      var track = g.querySelector('.ig-track');
      var prev = g.querySelector('[data-ig-prev]');
      var next = g.querySelector('[data-ig-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
      var shots = [].slice.call(g.querySelectorAll('.ig-shot'));
      shots.forEach(function (b, i) { b.addEventListener('click', function () { openLightbox(shots, i); }); });
    });

    // click-to-play video (YouTube id, or a Shopify-hosted <video> already in the block)
    root.querySelectorAll('.ig-video[data-ig-video]:not([data-ig-ready])').forEach(function (v) {
      v.setAttribute('data-ig-ready', '1');
      var yt = v.getAttribute('data-youtube');
      var href = v.getAttribute('href');
      v.addEventListener('click', function (e) {
        if (v.querySelector('iframe')) return;
        var native = v.querySelector('video');
        if (native) { e.preventDefault(); v.classList.add('is-playing'); native.controls = true; var p = native.play(); if (p && p.catch) p.catch(function () {}); return; }
        if (!yt) return; // plain link
        e.preventDefault();
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + yt + '?autoplay=1&rel=0';
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        f.allowFullscreen = true; f.title = v.getAttribute('aria-label') || 'Video';
        v.innerHTML = ''; v.appendChild(f); v.removeAttribute('href');
      });
    });
  }

  // lightbox (one per page)
  var lb, lbImg, lbCap, set = [], idx = 0;
  function ensureLightbox() {
    if (lb) return;
    lb = document.createElement('dialog'); lb.className = 'ig-lb'; lb.setAttribute('aria-label', 'Photo viewer');
    lb.innerHTML = '<div class="ig-lb__in"><img alt=""><button type="button" class="ig-lb__close" aria-label="Close"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="m3 3 10 10M13 3 3 13"/></svg></button><button type="button" class="ig-lb__prev" aria-label="Previous photo"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M10 3 5 8l5 5"/></svg></button><button type="button" class="ig-lb__next" aria-label="Next photo"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="m6 3 5 5-5 5"/></svg></button><div class="ig-lb__cap"></div></div>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('img'); lbCap = lb.querySelector('.ig-lb__cap');
    lb.querySelector('.ig-lb__close').addEventListener('click', function () { lb.close(); });
    lb.querySelector('.ig-lb__prev').addEventListener('click', function () { show(idx - 1); });
    lb.querySelector('.ig-lb__next').addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    document.addEventListener('keydown', function (e) { if (!lb.open) return; if (e.key === 'ArrowLeft') show(idx - 1); if (e.key === 'ArrowRight') show(idx + 1); });
  }
  function show(i) {
    idx = (i + set.length) % set.length;
    var b = set[idx], img = b.querySelector('img');
    lbImg.src = b.getAttribute('data-full') || img.currentSrc || img.src; lbImg.alt = img.alt || '';
    lbCap.textContent = b.getAttribute('data-cap') || '';
  }
  function openLightbox(shots, i) {
    ensureLightbox(); set = shots; show(i);
    if (typeof lb.showModal === 'function') lb.showModal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // theme editor: re-init when a section is (re)loaded
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* copy-block button plays the video in place rather than opening YouTube */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ig-playvideo]'); if (!b) return;
    var sec = b.closest('.ig-video-section'); if (!sec) return;
    var v = sec.querySelector('.ig-video[data-ig-video]'); if (!v) return;
    e.preventDefault();
    v.click();
    try { v.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) { v.scrollIntoView(); }
  });
})();
